import React, { useRef, useState } from 'react';
import { cx, css } from 'linaria';
import Image, { transparentDataImg } from '@jetshop/ui/Image/Image';
import ProductLink from '@jetshop/ui/ProductLink';

// import { getProductStructure } from '../../ElevateProductCard';
import { theme } from '../../../Theme';
import { styled } from 'linaria/react';
import { elevateProductToProductLink } from '../../helpers/elevateProductToProductLink';
import { PriceWrapper } from '../../ElevateProductCard';
import { Price } from '../../../Price';
import { getElevateMemberPrice } from '../../helpers/getElevateMemberPrice';
import { getPercentage } from '../../../../utils/getPercentage';

const wrapperStyling = css`
  a {
    text-decoration: none !important;
    color: inherit;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 16px;
    background: white;
    margin: 0 !important;
  }

  .product-card-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      color: #191c1d;
      font-family: Figtree;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      text-transform: uppercase;
      margin-bottom: 5px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 40px; /* 2 lines x 20px line-height */
    }

    .price-wrapper {
      [data-flight-price='true'] {
        margin-bottom: 0 !important;
        .price,
        .member-price {
          font-size: 20px;

          .currency {
            font-size: 12px;
            margin-bottom: 1px;
          }
        }
      }
    }
  }
`;

// [data-flight-image-container] {
//     background: rgba(0, 0, 0, 0.04);
//   }
//   [data-flight-image] {
//     mix-blend-mode: multiply;
//   }

const ImageWrapper = styled('div')`
  width: 100%;
  max-width: 64px;
`;

export const ElevateAutocompleteProductCard = ({
  productGroup,
  imageAspect = '1:1',
  imageSizes = '200',
  //   forwardRef,
  //   searchTerm = null,
  //   closeSearch,
  clickCallback = () => {},
  as = 'div'
}) => {
  const [product, setProduct] = useState(productGroup?.products?.[0]);
  const ElevateProductCardWrapper = as;

  const cardRef = useRef(null);

  //   const { trackClick } = useElevateClickTracking();

  const presentableProductName = () => {
    const nameConcated = product?.subName
      ? product?.subName + ' '
      : '' + product?.name ?? '';
    // return searchTerm
    //   ? getHighlightedText?.(nameConcated, searchTerm)
    //   : nameConcated;
    return nameConcated;
  };

  //   // Handle click tracking for Elevate
  //   const handleProductClick = () => {
  //     if (product?.ticket) {
  //       trackClick(product.ticket);
  //     }
  //     if (closeSearch) {
  //       closeSearch();
  //     }
  //   };

  const memberPrice = getElevateMemberPrice(product);

  const hasVariantPricing =
    product?.sellingPrice?.min !== product?.sellingPrice?.max;

  return (
    <ElevateProductCardWrapper
      ref={cardRef}
      className={cx('elevate-autocomplete-product-card', wrapperStyling)}
      data-testid="product"
      data-product-card
      //   ref={forwardRef}
    >
      <ProductLink
        product={elevateProductToProductLink(product)}
        style={{
          margin: '0 0.5em 1em'
        }}
        onClick={() => clickCallback(product)}
      >
        <ImageWrapper>
          {product?.imageInfo?.images?.length > 0 ? (
            <Image
              sizes={imageSizes}
              aspect={'64:84'}
              alt={product.title}
              src={product?.imageInfo?.images?.[0]?.sources?.[0]?.url}
              className={'image'}
              cover
              // fillAspect={true}
            />
          ) : (
            <Image src={transparentDataImg} />
          )}
        </ImageWrapper>

        <section className="product-card-detail">
          <header>
            <h3>{product?.title}</h3>
            <PriceWrapper
              fromText={'Fr.'}
              className={cx(
                hasVariantPricing ? 'price-range' : 'single-price',
                'price-wrapper'
              )}
            >
              <Price
                memberPrice={{ incVat: memberPrice }}
                price={{ incVat: product?.sellingPrice?.min }}
                previousPrice={{ incVat: product?.listPrice?.min }}
                fromPrice={
                  hasVariantPricing ? product?.sellingPrice?.min : null
                }
                fixedPercentage={getPercentage(product, memberPrice)}
              />
            </PriceWrapper>
          </header>
        </section>
      </ProductLink>
    </ElevateProductCardWrapper>
  );
};
